/* src/app/components/auth-usage-charts/spending-plan/spending-plan-detailed-summary/spending-plan-detailed-summary.component.css */
/*# sourceMappingURL=spending-plan-detailed-summary.component-IG46PGGP.css.map */
